import React from "react";
import DayColumn from "./DayColumn.jsx";
import {
  getWeekDays,
  isPast,
  isToday,
  toDateKey,
  weekdayIndex,
} from "../utils/date.js";
import { weekdayColumnStart } from "../utils/layout.js";
import { isInMonth } from "../utils/month.js";

/**
 * One week inside a month section.
 *
 * Only the days belonging to the section's month are rendered — the rest show
 * up in the neighbouring section instead. The first day of a partial week is
 * placed in its proper grid column so that every weekday keeps the same
 * column down the page; the remaining days flow after it.
 *
 * Mobile: one day per row. sm: two columns. md: three. lg: the full seven.
 *
 * @param {Date} weekStart Monday
 * @param {string} monthKey the section's month
 */
export default function WeekRow({
  weekStart,
  monthKey,
  byDate,
  today,
  overKey,
  composerDate,
  ...dayProps
}) {
  const days = getWeekDays(weekStart).filter((date) =>
    isInMonth(toDateKey(date), monthKey),
  );
  if (days.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7 lg:items-stretch">
      {days.map((date, index) => {
        const dateKey = toDateKey(date);
        return (
          <DayColumn
            key={dateKey}
            date={date}
            dateKey={dateKey}
            // Only the first day needs placing; the others follow on naturally.
            className={
              index === 0 ? weekdayColumnStart(weekdayIndex(date)) : ""
            }
            occurrences={byDate[dateKey] || []}
            today={isToday(date, today)}
            past={isPast(date, today)}
            isOver={overKey === dateKey}
            composing={composerDate === dateKey}
            {...dayProps}
          />
        );
      })}
    </div>
  );
}
